module.exports = __webpack_public_path__ + "img/scene_industry.36388c36.webp";